import { AxiosError } from 'axios';
import { useAPI } from './useAPI';

/*
hook will be used for fetching listing for table UI
Error will be handled by Parent
*/

interface IUseRetrieve {
  queryKey?: string[];
  url: string;
  params?: Record<string, any>;
  staleTime?: number;
  enabled?: boolean;
  onSuccess?: Function;
  onError?: (error: AxiosError<any>) => void;
  refetchInterval?: number | false;
  refetchOnWindowFocus?: boolean;
  /*
    What to show while a changed `params` loads. Pass `(previous) => previous` to keep the last
    answer on screen - otherwise new params mean no data and `isLoading` again, and a caller that
    renders a loader in its place unmounts everything below it.
  */
  placeholderData?: (previousData: any) => any;
}

export default function useRetrieve({
  queryKey,
  url,
  params,
  staleTime = 0,
  enabled = true,
  onSuccess,
  onError,
  refetchInterval,
  refetchOnWindowFocus,
  placeholderData,
}: IUseRetrieve) {
  return useAPI({
    queryKey,
    method: 'get',
    url,
    params,
    staleTime,
    enabled,
    onSuccess,
    onError,
    refetchInterval,
    refetchOnWindowFocus,
    placeholderData,
  });
}
